import { prop } from '@gov-nx/core/types/helpers.types';
import { usePersistedStore } from '../constants';
import type { TranslationsState } from './store.types';

const initialState = {
	translations: {},
};

const useStore = <T>(selector: (state: TranslationsState) => T) =>
	usePersistedStore(
		(set, get) => ({
			...initialState,

			updateTranslations: (translations, key) =>
				set((state: TranslationsState) => ({
					translations: {
						...state.translations,
						[key]: translations,
					},
				})),

			getTranslationsByKey: (key: string) => get().translations?.[key],
		}),
		'translations',
		selector
	);

export const useTranslationsStore = <T extends keyof TranslationsState>(
	property: T
): TranslationsState[T] => useStore(prop(property));
